<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <header class="has-text-centered">
        <p class="is-size-5 has-text-weight-bold">
          {{ $t('detailContrat.indexation.popUpIndexation.titleEcheancier') }}
        </p>
      </header>
      <section class="mgt-4">
        <resume-indexation :item-indexe="echeancier" for-echeancier :showDate="showDate"/>
      </section>
      <footer class="mgt-4">
        <div class="buttons">
          <button
            class="button has-text-centered"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import resumeIndexation from '@/components/baux/contrat/componentDetail/popUpIndexationBail/ResumeIndexation';

export default {
  props: {
    echeancier: {
      type: Object,
      required: true,
    },
    showDate: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    resumeIndexation,
  },
};
</script>
